import { Component } from '@angular/core';
import { AuthService } from 'lib-auth';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AbstractAppRootComponent } from 'lib-components';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

@Component({
    selector: 'app-root',
    templateUrl: './app-root.component.html',
    styleUrls: ['./app-root.component.scss'],
    standalone: false
})
export class AppRootComponent extends AbstractAppRootComponent {

    constructor(router: Router, authService: AuthService, translateService: TranslateService) {
        super(router, authService, translateService, environment);
        dayjs.locale('fr');
    }
}
